import { FC } from 'react'
import { MarketingConsent } from '.'
import {
  JoinLayout,
  StepCommonProps,
  withOpenAccountCaptureDefaults,
} from '../OpenAccountPage'
import { useOnboardingSteps } from '@/context/OnboardingStepContext/OnboardingStepContext'

export const MarketingConsentStep: FC<StepCommonProps> = ({ setFormData }) => {
  const { goForward } = useOnboardingSteps()
  return (
    <JoinLayout title="To get the good stuff, we need your consent">
      <MarketingConsent
        onSubmit={() => {
          setFormData(prev => ({
            ...withOpenAccountCaptureDefaults(prev),
          }))
          goForward()
        }}
      />
    </JoinLayout>
  )
}
